import { generatePath } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';

export const makeDynamicHelpBlogUrl = (dealId: string | undefined, url: string): string => {
	return dealId ? generatePath(`${ROUTES.DEAL}${url}`, { dealId }) : url;
};

// Fixes node IDs starting with a number. `.querySelector()` doesn't work with IDs starting with a number
export const prefixHelpBlogNodeKey = (key: string) => `help-blog-${key}`;
